import { render } from "./PhenologicalPhaseBadge.vue?vue&type=template&id=8412a620&ts=true"
import script from "./PhenologicalPhaseBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhenologicalPhaseBadge.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/PhenologicalPhaseBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8412a620"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8412a620', __exports__)) {
    console.log('reload')
    api.reload('8412a620', __exports__)
  }
  
  module.hot.accept("./PhenologicalPhaseBadge.vue?vue&type=template&id=8412a620&ts=true", () => {
    console.log('re-render')
    api.rerender('8412a620', render)
  })

}


export default __exports__